import { render, staticRenderFns } from "./recent-project-cards.vue?vue&type=template&id=3ea733b5&scoped=true"
import script from "./recent-project-cards.vue?vue&type=script&lang=js"
export * from "./recent-project-cards.vue?vue&type=script&lang=js"
import style0 from "./recent-project-cards.vue?vue&type=style&index=0&id=3ea733b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea733b5",
  null
  
)

export default component.exports